import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import MetricSlider from '../../../components/metricSlider/MetricSlider';
import RankingCard from '../../../components/rankingCard/RankingCard';
import { StackRankCard } from '../../../components/rankingCard/StackRankCard';
import { AGENTROLE, SUPERVISORROLE } from '../../../constants';
import { selectCurrentRole } from '../../../pages/login/authSlice';
import { useGetstackRankSearchQuery } from '../../../pages/scorecardDashboard/scorecardDashboardSlice';
import {
    MetricDetail,
    RankingItem,
    extractAndSortMetricDetailsById,
    getNameById,
} from '../../../pages/stackRank/types';
import { ConstScorecardRole } from '../../../utils/typeConstants';
import './MetricRankings.scss';

interface MetricRankingsProps {
    empNum?: string;
    inputMonth: number;
    inputYear: number;
    scorecardVersionID: number | string;
}

const MetricRankings: React.FC<MetricRankingsProps> = ({
    empNum,
    inputMonth,
    inputYear,
    scorecardVersionID,
}) => {
    const role = useSelector(selectCurrentRole);
    const [stackRankData, setStackRankData] = useState<any>(null);
    const [allRankingData, setAllRankingData] = useState<any>([]);
    const [top3RankingData, setTop3RankingData] = useState<any>([]);
    const [selectedUserInGrid, setSelectedUserInGrid] = useState<any>(null);
    const [selectedMetric, setSelectedMetric] = useState<string>();
    const [metricId, setMetricId] = useState(0);
    const [scorecardRoleId, setScorecardRoleId] = useState<number>(0);
    const [metricType, setMetricType] = useState('');

    useEffect(() => {
        if (role === AGENTROLE) {
            setScorecardRoleId(ConstScorecardRole.ASSOCIATE);
        } else if (role === SUPERVISORROLE) {
            setScorecardRoleId(ConstScorecardRole.TEAM_LEAD);
        } else {
            setScorecardRoleId(0);
        }
    }, [role]);

    const { data: stackRankSearchData } = useGetstackRankSearchQuery(
        {
            employeenumber: empNum ? parseInt(empNum, 10) : 0,
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: scorecardVersionID,
            ScorecardRoleId: scorecardRoleId,
        },
        { skip: !empNum || !scorecardVersionID || !inputMonth || !inputYear || !scorecardRoleId }
    );

    useEffect(() => {
        if (
            scorecardVersionID !== '' &&
            Number(scorecardVersionID) > 0 &&
            stackRankSearchData?.data?.length > 0
        ) {
            const filtered = Array.isArray(stackRankSearchData.data) ? [...stackRankSearchData.data] : [];

            if (!selectedUserInGrid) {
                const loggedInUserRecord = stackRankSearchData.data.find(
                    (row: any) => row.employee_number === empNum
                );
                setSelectedUserInGrid(loggedInUserRecord);
            }
            setStackRankData(filtered);
        } else {
            setStackRankData([]);
            setTop3RankingData([]);
            setAllRankingData([]);
            setSelectedMetric('');
            setSelectedUserInGrid(null);
        }
    }, [stackRankSearchData, scorecardRoleId, scorecardVersionID, inputMonth, inputYear]);

    const data = Array.isArray(stackRankData) ? stackRankData : [];

    const response = data.length > 0 && data[0]?.agentMetrics[0]?.metricsDetails;
    const metricArray = Object.entries(response).map(([metricName, details]) => {
        const metricDetail = details as MetricDetail;
        return {
            id: metricDetail.metric_id,
            name: metricName,
            type: metricDetail.metric_type_name,
            content: '',
            agentName: '',
            smiley: '',
        };
    });

    const handleMetricChange = (id: number, type: string) => {
        if (
            scorecardVersionID !== '' &&
            Number(scorecardVersionID) > 0 &&
            stackRankSearchData?.data?.length > 0
        ) {
            setMetricId(id);
            setMetricType(type);
            setSelectedMetric(getNameById(metricArray, id));
        }
    };

        useEffect(() => {
        console.log('MetricRankings metricType', metricType);
    }, []);
    console.log('selectedMetric', selectedMetric);


    useEffect(() => {
        setAllRankingData([]);
        setTop3RankingData([]);
        if (stackRankData?.length > 0) {
            const { all, top3 } = extractAndSortMetricDetailsById(
                stackRankData,
                metricId,
                selectedUserInGrid,
                empNum
            );
            setTop3RankingData(top3);
            setAllRankingData(all);
        } else {
            setAllRankingData([]);
            setTop3RankingData([]);
        }
    }, [stackRankData, metricId, selectedUserInGrid, selectedMetric, inputMonth, inputYear]);

    return (
        <div className="metric-rankings-wrapper">
            <div className="ranking-card-container">
                <div className="ranking-lists-wrapper">
                    {metricArray.length > 0 && (
                        <div className="metric-slider-wrapper">
                            <MetricSlider metrics={metricArray} onMetricChange={handleMetricChange} />
                        </div>
                    )}

                    <div className="ranking-list1">
                        <StackRankCard data={top3RankingData} selectedMetric={selectedMetric} />
                    </div>
                    <div className="ranking-list2">
                    {allRankingData.map((card: RankingItem) => (
                        <RankingCard key={card.employee_name} {...card} selectedMetric={selectedMetric} />
                    ))}
                </div>
                </div>
            </div>
        </div>
    );
};

export default MetricRankings;
